import { Injectable } from '@angular/core';
import { SlideComponent } from './slide/slide.component';
import { Location } from '@angular/common';

@Injectable()
export class SlideRouterService {
  private _slides = new SlidePointerDatadabase();
  private _callbacks: ((slideIndex: number, pointIndex: number, slide: SlideComponent) => any)[] = [];

  constructor(private _location: Location) {
    this._location.subscribe(e => this._handleRouteChange(e));
  }

  private _handleRouteChange(e: any) {
    this.handleUrl(e.url);
  }

  handleCurrentUrl(defaultIndex = 0) {
    this.handleUrl(this.path);
  }

  private _getCurrentIndex(url?: string) {
    return parseSlideUrl(url || this.path);
  }

  onRouteChange(cb: (slideIndex: number, pointIndex: number, slide: SlideComponent) => any) {
    this._callbacks.push(cb);
    const result = this._slides.lookup(this._getCurrentIndex());
    if (result) {
      const [slideIndex, slide, pointIndex] = result;
      cb(slideIndex, pointIndex, slide);
    }
  }

  handleUrl(url: string) {
    let index = this._getCurrentIndex(url);
    if (index < 0) {
      this._gotoIndex(0);
    } else if (index > this._slides.maxIndex) {
      this._gotoIndex(this._slides.maxIndex);
    } else {
      const result = this._slides.lookup(index);
      if (result) {
        const [slideIndex, slide, pointIndex] = result;
        this._callbacks.forEach(cb => {
          cb(slideIndex, pointIndex, slide);
        });
        this.focusOnSlide(slideIndex, slide, pointIndex);
      }
    }
  }

  focusOnSlide(slideIndex: number, slide: SlideComponent, pointIndex: number) {
    this._slides.getAll().forEach((s, i) => {
      if (i < slideIndex) {
        s.blur();
        s.showAllFragments();
      } else if (slideIndex === i) {
        s.focus();
        s.showFragment(pointIndex);
      } else {
        s.blur();
        s.hideAllFragments();
      }
    });
  }

  get path() {
    return this._location.path();
  }

  private _gotoIndex(index: number) {
    this._go('/' + index + '/');
  }

  private _go(path: string) {
    this._location.go(path);
    this.handleUrl(path);
  }

  registerSlide(slide: SlideComponent): number {
    const index = this._slides.maxIndex;
    this._slides.push(slide);
    return index;
  }

  getSlides() {
    return this._slides;
  }

  previous() {
    const index = this._getCurrentIndex();
    if (index > 0) {
      this._gotoIndex(index - 1);
    }
  }

  next() {
    const index = this._getCurrentIndex();
    if (index < this._slides.maxIndex) {
      this._gotoIndex(index + 1);
    }
  }

  down() {
    const index = this._getCurrentIndex();
    if (index < this._slides.maxIndex) {
      const [iA, slideA, diffA] = this._slides.lookup(index);
      const [iB, slideB, diffB] = this._slides.lookup(index + 1);
      if (slideA === slideB) {
        this._gotoIndex(index + 1);
      }
    }
  }

  up() {
    const index = this._getCurrentIndex();
    if (index < this._slides.maxIndex) {
      const [iA, slideA, diffA] = this._slides.lookup(index);
      const [iB, slideB, diffB] = this._slides.lookup(index - 1);
      if (slideA === slideB) {
        this._gotoIndex(index - 1);
      }
    }
  }

  back() {
    this._location.back();
  }

  forward() {
    this._location.forward();
  }

  left() {
    this.previous();
  }

  right() {
    this.next();
  }
}

class SlidePointerDatadabase {
  private _slides: SlideComponent[] = [];
  public maxIndex = 0;

  push(slide: SlideComponent) {
    this._slides.push(slide);
    this.maxIndex += slide.fragments.length + 1;
  }

  lookup(index: number): [number, SlideComponent, number]|null {
    for (let i = 0, x = 0; i < this._slides.length; i++) {
      const slide = this._slides[i];
      const l = slide.fragments.length + 1;
      const y = x + l;
      if (y > index) {
        const diff = index === x ? - 1 : (index - x - 1);
        return [i, slide, diff];
      }
      x = y;
    }
  }

  getAll() {
    return this._slides;
  }
}

function parseSlideUrl(path: string) {
  const index = (/^\/(\d+)\/?/.exec(path) || [null, null])[1];
  return index === null ? -1 : parseInt(index);
}



// WEBPACK FOOTER //
// ./src/app/slide-router.service.ts